/* TRENZLY THEME JS  |  vanilla JS, no dependencies */
(function () {
  'use strict';
  var R = (window.TZ && window.TZ.routes) || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- helpers ---------- */
  function toast(msg) {
    var t = $('#tz-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-show');
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.classList.remove('is-show'); }, 2800);
  }
  function formatMoney(cents) {
    var fmt = (window.TZ && window.TZ.moneyFormat) || '{{amount}}';
    var v = cents / 100;
    function fix(n, d, th, dec) {
      var s = n.toFixed(d).split('.');
      s[0] = s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return s.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return fix(v, 2, ',', '.');
        case 'amount_no_decimals': return fix(v, 0, ',', '.');
        case 'amount_with_comma_separator': return fix(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(v, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fix(v, 2, "'", '.');
        default: return fix(v, 2, ',', '.');
      }
    });
  }

  /* ---------- overlay / drawers ---------- */
  var overlay = $('[data-overlay]');
  function lock(on) { document.body.classList.toggle('is-locked', on); }
  function openEl(el, ov) {
    if (!el) return;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    if (ov) { ov.hidden = false; requestAnimationFrame(function () { ov.classList.add('is-open'); }); }
    lock(true);
  }
  function closeEl(el, ov) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (ov) { ov.classList.remove('is-open'); setTimeout(function () { ov.hidden = true; }, 300); }
    lock(false);
  }

  /* mobile menu */
  var menu = $('#mobile-menu');
  $$('[data-open-menu]').forEach(function (b) { b.addEventListener('click', function () { openEl(menu, overlay); }); });
  $$('[data-close-menu]').forEach(function (b) { b.addEventListener('click', function () { closeEl(menu, overlay); }); });
  if (overlay) overlay.addEventListener('click', function () { closeEl(menu, overlay); });

  /* search panel */
  var sp = $('#search-panel');
  $$('[data-toggle-search]').forEach(function (b) {
    b.addEventListener('click', function () {
      sp.hidden = !sp.hidden;
      if (!sp.hidden) { var i = $('input[type=search]', sp); if (i) i.focus(); }
    });
  });

  /* cart drawer */
  var drawer = $('[data-cart-drawer]');
  var cartOverlay = $('[data-cart-overlay]');
  function openCart() { openEl(drawer, cartOverlay); }
  function closeCart() { closeEl(drawer, cartOverlay); }
  $$('[data-close-cart]').forEach(function (b) { b.addEventListener('click', closeCart); });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  $$('[data-cart-link]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (window.TZ.cartType === 'drawer' && drawer) { e.preventDefault(); openCart(); }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCart(); closeEl(menu, overlay); closeFilters();
  });

  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', n === 0); });
    var c = $('.cart-drawer__count'); if (c) c.textContent = '(' + n + ')';
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function refreshCart() {
    return fetch(R.cartJson, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        var jobs = [];
        if (drawer) {
          jobs.push(fetch(R.root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
            var doc = parseHTML(j['cart-drawer']); var fresh = $('[data-cart-drawer]', doc);
            if (fresh) { drawer.innerHTML = fresh.innerHTML; drawer.classList.remove('is-loading'); updateCount(cart.item_count); }
          }));
        }
        var page = $('[data-cart-page]');
        if (page) {
          jobs.push(fetch(R.cart).then(function (r) { return r.text(); }).then(function (html) {
            var fresh = $('[data-cart-page]', parseHTML(html));
            if (fresh) { page.innerHTML = fresh.innerHTML; page.classList.remove('is-loading'); }
          }));
        }
        return Promise.all(jobs).then(function () { return cart; });
      });
  }

  function changeLine(line, qty) {
    var page = $('[data-cart-page]');
    if (drawer) drawer.classList.add('is-loading');
    if (page) page.classList.add('is-loading');
    return fetch(R.cartChange, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(qty, 10) || 0) })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.errors || data.description) toast(data.description || data.errors);
      return refreshCart();
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (b) { e.preventDefault(); changeLine(b.getAttribute('data-line-change'), b.getAttribute('data-qty')); }
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-line-input]');
    if (i) changeLine(i.getAttribute('data-line-input'), i.value);
  });

  function addToCart(form, btn) {
    var fd = new FormData(form);
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    return fetch(R.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || 'Could not add to cart'); return; }
        return refreshCart().then(function () {
          if (window.TZ.cartType === 'drawer' && drawer) { openCart(); }
          else if (window.TZ.cartType === 'page') { window.location.href = R.cart; }
          else { toast('Added to cart'); }
        });
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('.js-ajax-add, .js-product-form')) {
      e.preventDefault();
      addToCart(f, f.querySelector('button[type=submit]'));
    }
  });

  /* ---------- announcement rotator ---------- */
  var ann = $('[data-announce]');
  if (ann) {
    var msgs = $$('.announce__msg', ann), idx = 0, sp2 = parseInt(ann.getAttribute('data-speed'), 10) || 5000;
    if (msgs.length > 1) setInterval(function () {
      msgs[idx].classList.remove('is-active'); idx = (idx + 1) % msgs.length; msgs[idx].classList.add('is-active');
    }, sp2);
  }

  /* ---------- hero slider ---------- */
  function initSlider(root) {
    var slides = $$('[data-slide]', root), dots = $$('[data-dot]', root), cur = 0, timer;
    var auto = root.getAttribute('data-autoplay') === 'true', speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;
    if (slides.length < 2) return;
    function go(n) {
      slides[cur].classList.remove('is-active'); if (dots[cur]) dots[cur].classList.remove('is-active');
      cur = (n + slides.length) % slides.length;
      slides[cur].classList.add('is-active'); if (dots[cur]) dots[cur].classList.add('is-active');
    }
    function play() { if (auto) { stop(); timer = setInterval(function () { go(cur + 1); }, speed); } }
    function stop() { clearInterval(timer); }
    var p = $('[data-prev]', root), n = $('[data-next]', root);
    if (p) p.addEventListener('click', function () { go(cur - 1); play(); });
    if (n) n.addEventListener('click', function () { go(cur + 1); play(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-dot'), 10)); play(); }); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', play);
    var sx = null;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) go(cur + (dx < 0 ? 1 : -1)); sx = null; play();
    });
    play();
  }
  $$('[data-slider]').forEach(initSlider);

  /* ---------- product page ---------- */
  function initProduct(sec) {
    var jsonEl = $('[data-variants-json]', sec); if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var fieldsets = $$('.opt', sec);
    var idInput = $('[data-variant-id]', sec), addBtn = $('[data-add-btn]', sec), addLbl = $('[data-add-label]', sec);
    var priceNow = $('[data-price-now]', sec), priceWas = $('[data-price-was]', sec), priceSave = $('[data-price-save]', sec);
    var stock = $('[data-stock]', sec);
    var slides = $$('.pdp__slide', sec), thumbs = $$('[data-thumb]', sec);

    function selected() {
      return fieldsets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function findVariant(sel) {
      return variants.filter(function (v) { return sel.every(function (s, i) { return v.options[i] === s; }); })[0];
    }
    function showMedia(id) {
      if (!id) return;
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') == id); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') == id); });
    }
    function markUnavailable(sel) {
      fieldsets.forEach(function (fs, i) {
        $$('input', fs).forEach(function (inp) {
          var ok = variants.some(function (v) {
            return v.options[i] === inp.value && sel.every(function (s, j) { return j === i || v.options[j] === s; }) && v.available;
          });
          inp.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function update() {
      var sel = selected();
      fieldsets.forEach(function (fs, i) { var l = $('[data-option-label]', fs); if (l) l.textContent = sel[i]; });
      markUnavailable(sel);
      var v = findVariant(sel);
      if (!v) { addBtn.disabled = true; addLbl.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceNow.textContent = formatMoney(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        priceWas.hidden = false; priceWas.textContent = formatMoney(v.compare_at_price);
        priceSave.hidden = false; priceSave.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
        priceNow.parentNode.classList.add('price--sale');
      } else { priceWas.hidden = true; priceSave.hidden = true; priceNow.parentNode.classList.remove('price--sale'); }
      addBtn.disabled = !v.available; addLbl.textContent = v.available ? 'Add to cart' : 'Sold out';
      idInput.disabled = !v.available;
      if (stock) {
        if (v.available && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5) {
          stock.textContent = 'Hurry, only ' + v.inventory_quantity + ' left in stock'; stock.className = 'pdp__stock';
        } else if (v.available) { stock.textContent = ''; } else { stock.textContent = 'This option is currently sold out'; stock.className = 'pdp__stock'; }
      }
      if (v.featured_media) showMedia(v.featured_media.id);
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
    }
    $$('[data-opt-input]', sec).forEach(function (i) { i.addEventListener('change', update); });
    markUnavailable(selected());

    /* gallery */
    function currentIndex() { var a = slides.filter(function (s) { return s.classList.contains('is-active'); })[0]; return slides.indexOf(a); }
    function step(d) { var n = (currentIndex() + d + slides.length) % slides.length; showMedia(slides[n].getAttribute('data-media-id')); }
    var gp = $('[data-gprev]', sec), gn = $('[data-gnext]', sec);
    if (gp) gp.addEventListener('click', function () { step(-1); });
    if (gn) gn.addEventListener('click', function () { step(1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
    var main = $('.pdp__main', sec), sx = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1); sx = null; });
    }

    /* quantity */
    var qi = $('[data-pqty-input]', sec);
    $$('[data-pqty]', sec).forEach(function (b) {
      b.addEventListener('click', function () { qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) + parseInt(b.getAttribute('data-pqty'), 10)); });
    });
  }
  $$('[data-product-section]').forEach(initProduct);

  /* product recommendations */
  $$('.product-recs').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var fresh = $('.product-recs', parseHTML(html));
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    });
  });

  /* ---------- collection filters ---------- */
  var filters = $('#filters'), filterOverlay = $('[data-filter-overlay]');
  function openFilters() { openEl(filters, filterOverlay); }
  function closeFilters() { closeEl(filters, filterOverlay); }
  $$('[data-open-filters]').forEach(function (b) { b.addEventListener('click', openFilters); });
  $$('[data-close-filters]').forEach(function (b) { b.addEventListener('click', closeFilters); });
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilters);
  var ff = $('[data-filter-form]');
  if (ff) {
    var ft;
    ff.addEventListener('change', function () { clearTimeout(ft); ft = setTimeout(function () { ff.submit(); }, 350); });
  }
  var sortSel = $('[data-sort-select]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(window.location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); window.location.href = u.toString();
  });

  /* copy promo code */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy-code]'); if (!b) return;
    var code = b.getAttribute('data-copy-code');
    function done() { toast('Code ' + code + ' copied. Apply it at checkout.'); }
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done, done); }
    else { var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (err) {} t.remove(); done(); }
  });

  /* track order via WhatsApp */
  var tf = $('[data-track-form]');
  if (tf) tf.addEventListener('submit', function (e) {
    e.preventDefault();
    var num = tf.querySelector('input[name=order]').value.trim();
    var wa = tf.getAttribute('data-wa');
    var msg = encodeURIComponent('Hi Trenzly, please share the tracking status for my order ' + num);
    window.open('https://wa.me/' + wa + '?text=' + msg, '_blank');
  });

  /* close drawer on back/forward cache restore */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { lock(false); } });
})();

/* ---------- v1.6: size chart modal + inch/cm switch ---------- */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open-sizes]');
    if (open) {
      var wrap = open.closest('.pdp__sizechart');
      var dlg = wrap && wrap.querySelector('[data-sizes-modal]');
      if (dlg) { if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); } }
      return;
    }
    if (e.target.closest('[data-close-sizes]')) {
      var d = e.target.closest('dialog');
      if (d) { if (typeof d.close === 'function') { d.close(); } else { d.removeAttribute('open'); } }
      return;
    }
    var dlgBg = e.target;
    if (dlgBg && dlgBg.matches && dlgBg.matches('[data-sizes-modal]')) { dlgBg.close(); return; }
    var unitBtn = e.target.closest('[data-unit]');
    if (unitBtn) {
      var box = unitBtn.closest('[data-sizes]'); if (!box) return;
      var unit = unitBtn.getAttribute('data-unit');
      Array.prototype.forEach.call(box.querySelectorAll('[data-unit]'), function (b) { b.classList.toggle('is-active', b === unitBtn); });
      Array.prototype.forEach.call(box.querySelectorAll('td[data-val]'), function (td) {
        var raw = td.getAttribute('data-val'); var n = parseFloat(raw);
        if (isNaN(n) || /[a-z]/i.test(raw) || raw.indexOf(' to ') > -1) { td.textContent = raw; return; }
        td.textContent = unit === 'cm' ? (Math.round(n * 2.54 * 10) / 10).toString() : raw;
      });
    }
  });

  /* Trenzly collection-card color swatches */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-card-swatch]');
    if (!swatch) return;
    e.preventDefault();
    var card = swatch.closest('.pcard');
    if (!card) return;
    var imageUrl = swatch.getAttribute('data-card-swatch-image');
    var image = card.querySelector('.pcard__media .pcard__img:not(.pcard__img--hover)');
    if (image && imageUrl) {
      image.src = imageUrl;
      image.removeAttribute('srcset');
      image.alt = swatch.getAttribute('data-card-swatch-value') || '';
    }
    card.querySelectorAll('[data-card-swatch]').forEach(function (button) {
      var active = button === swatch;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  });
})();
